import comp from "./AssessmentToolChooseListV2";
export default comp;
